<template>
	<el-dialog title="复制样品" append-to-body :visible.sync="dialogVisible" :close-on-click-modal="false" width="616px">
		<el-form style="width: 547px;" :model="dataForm" label-width="99px">
			<el-form-item label="复制份数" prop="failCause">
				<el-input type="number" v-model="dataForm.number"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer">
			<el-button @click="dialogVisible = false">取 消</el-button>
			<el-button type="primary" @click="dataSubmit">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		data() {
			return {
				dialogVisible: false,
				orderId: '',
				dataForm: {
					number:1
				}
			};
		},
		methods: {
			init(orderId,goodsId) {
				this.dataForm.number = 1;
				this.dataForm.orderId = orderId;
				this.dataForm.templateGoodsId = goodsId;
				this.dialogVisible = true;
			},
			dataSubmit() {
				if(!this.dataForm.number){
					this.$message({
								message: "请输入复制份数",
								type: "error"
							});
					return
				}
				this.$http.post(this.$api.orderApi.copyGoods, this.dataForm).then(({
					data
				}) => {
					this.$message({
						message: data.msg,
						type: "success"
					});
					this.dialogVisible = false;
					// 刷新样品列表
					this.$emit("refreshDataList");
				});
			}
		}
	};
</script>

<style lang="scss" scoped>
	::v-deep .el-dialog__footer {
		margin-top: 0;

		.el-button {
			width: 80px;
			line-height: 38px;
			border-radius: 20px;
			font-size: 14px;
		}
	}
</style>
